type AutoresponderParameter = {
  nome: string;
  label: string;
  tipo: string;
  botao_url?: string;
  botao_titulo?: string;
  tooltip?: string;
  campo_carregar?: string;
};

type Autoresponder = {
  id: number;
  name: string;
  image?: string;
  parameters?: {
    parametros: AutoresponderParameter[];
  };
};

export type ConnectFormData = {
  [key: string]: any;
  active: boolean;
  description: string | null;
  autoresponder: Autoresponder | null;
  autoresponder_id?: number;
  fields?: Record<string, string>;
};

export type ConnectItem = {
  [key: string]: any;
  id: number;
  name: string;
  image?: string;
  description: string | null;
  active: boolean;
  autoresponder_id: number;
  parameters?: Array<{ label: string; value: string }>;
  migrated?: boolean;
};

export type ActionData = {
  [key: string]: any;
  active: boolean;
  description: string | null;
  trigger_id: number | null;
  option_id: number | null;
  fields: Record<string, any>;
  options_parameters: Record<string, any>;
  products_id?: number[];
};

export type ConnectStateValue = {
  newConnect: ConnectFormData;
  currentConnect: ConnectItem | null;
  step: number;
  modalNewConnect: boolean;

  openNewConnectModal: () => void;
  closeNewConnectModal: () => void;
  setNewConnect: (data: ConnectFormData) => void;
  setCurrentConnect: (connect: ConnectItem) => void;
  setStep: (step: number) => void;
  nextStep: () => void;
  previousStep: () => void;
};

export type ActionStateValue = {
  newAction: ActionData;
  currentAction: ActionData;
  modalNewAction: boolean;
  modalEditAction: boolean;
  stepAction: number;
  optionsAction: Record<string, any>;

  openNewActionModal: () => void;
  closeNewActionModal: () => void;
  setNewAction: (data: ActionData) => void;
  setStepAction: (step: number) => void;
  nextStepAction: () => void;
  previousStepAction: () => void;

  openEditActionModal: () => void;
  closeEditActionModal: () => void;
  setCurrentAction: (action: ActionData) => void;

  addOptionAction: (field: string, value: any) => void;
  resetOptionsAction: () => void;
  resetOptionAction: (field: string) => void;
};

export const DEFAULT_NEW_CONNECT: ConnectFormData = {
  active: true,
  description: null,
  autoresponder: null
};

export const DEFAULT_ACTION: ActionData = {
  active: true,
  description: null,
  trigger_id: null,
  option_id: null,
  fields: {},
  options_parameters: {}
};
